import { useContext } from 'react';

import {
  InstallationGuideContext,
  InstallationGuideContextValue,
} from '../components/installation-guide/InstallationGuideProvider';

/**
 * useInstallationGuide - Hook to access installation guide context
 * 
 * Provides access to the current state and actions for the installation
 * guide wizard. Must be used within an InstallationGuideProvider.
 * 
 * @returns The installation guide context value
 * @throws Error if used outside of InstallationGuideProvider
 * 
 * @example
 * ```tsx
 * const { 
 *   deviceSerial, 
 *   deviceModel, 
 *   goToNextStep,
 *   currentStepNumber,
 * } = useInstallationGuide();
 * ```
 */
export const useInstallationGuide = (): InstallationGuideContextValue => {
  const context = useContext(InstallationGuideContext);
  
  if (context === undefined) {
    throw new Error(
      'useInstallationGuide must be used within an InstallationGuideProvider'
    );
  }
  
  return context;
};
